import { render, staticRenderFns } from "./RemoveDevice.vue?vue&type=template&id=8d5c3d08&scoped=true"
import script from "./RemoveDevice.vue?vue&type=script&lang=js"
export * from "./RemoveDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5c3d08",
  null
  
)

export default component.exports